import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NxLayoutComponent } from './nx-layout.component';
import { FlexLayoutModule } from '@angular/flex-layout';



@NgModule({
  declarations: [
    NxLayoutComponent
  ],
  imports: [
    CommonModule,
    FlexLayoutModule
  ],
  exports: [
    NxLayoutComponent
  ]
})
export class NxLayoutModule { }
